import { IAuthToken, IAuthorizedUser } from '../models';
import { axios } from '../helpers';

const baseUrl = '/api/Admin/User';

export const getMe = async (token: string): Promise<IAuthorizedUser> => {
  try {
    const res = await axios.get(`${baseUrl}/Me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res && res.data) {
      return res.data;
    }
    const error = { detail: 'There was a problem finding this user.', statusCode: 500 };
    return Promise.reject(error);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postAuth = async (token: string): Promise<IAuthToken> => {
  const res = await axios.post(
    `${baseUrl}/Auth`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (res && res.data) {
    return res.data;
  }

  const error = { detail: 'There was a problem authenticating this user.', statusCode: 500 };
  return Promise.reject(error);
};
